import { CompanyInterface } from '@interfaces/Company.interface';
import { CompanyRelationshipIntelligence } from './types';

function hasRelationshipIntelligencePayload(
  company: CompanyInterface
): company is CompanyInterface & {
  relationship_intelligence: CompanyRelationshipIntelligence;
} {
  return company.relationship_intelligence != null;
}

/**
 * Prefer API-provided RI fields. Returns null when the API has not sent them yet.
 */
export function resolveCompanyRelationshipIntelligence(
  company: CompanyInterface
): CompanyRelationshipIntelligence | null {
  if (hasRelationshipIntelligencePayload(company)) {
    return company.relationship_intelligence;
  }

  return null;
}

export function withCompanyRelationshipIntelligence(
  company: CompanyInterface
): CompanyInterface {
  return company;
}

export function withCompanyListRelationshipIntelligence(
  companies: CompanyInterface[]
): CompanyInterface[] {
  return companies;
}
